/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Con tecnologia Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Con tecnologia AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'I contenuti si basano sulle tue autorizzazioni e la loro qualità può variare',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'La qualità dei contenuti può variare',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated':
    "Utilizza l'intelligenza artificiale. Verifica i risultati.",
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informazioni',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Includi le informazioni della pagina corrente',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Logo di Atlassian Intelligence',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Indietro',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Annulla',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Annulla',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Annulla',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Risposta sbagliata',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback inviato',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Risposta corretta',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': "Continua dall'ultima risposta",
  'fabric.editor.ai.config.item.action.copyResponse': 'Copia',
  'fabric.editor.ai.config.item.action.responseCopied': 'Copiato.',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Copiato negli Appunti',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Riprova',
  'fabric.editor.ai.experience-application.documentInsertError':
    "Stiamo riscontrando problemi nell'inserimento della risposta. Chiudi la finestra di dialogo e riprova.",
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Impossibile ottenere una risposta. La tua richiesta o risposta superava il limite consentito per questa richiesta. Chiudi la finestra di dialogo e riprova.',
  'fabric.editor.ai.experience.apiError': 'Impossibile ottenere una risposta, riprova.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.inputTooShortError':
    'Il contenuto è troppo breve per essere riassunto. Aggiungine altro e riprova.',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Generazione in corso',
  'fabric.editor.ai.experience.previewScreenLabel': 'Anteprima',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    "Chiedi all'assistente di scrivere qualcosa o effettua una scelta di seguito",
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logo di Rovo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Indietro',
  'fabric.editor.ai.screens.discard.discardLabel': 'Ignora',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Avviso',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Errore',
  'fabric.editor.ai.screens.error.cancelLabel': 'Annulla',
  'fabric.editor.ai.screens.error.retryLabel': 'Riprova',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Contenuti ad aggiornamento in tempo reale:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Icona di generazione',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel':
    "Azioni per i contenuti generati dall'intelligenza artificiale",
  'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Annulla',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Indica ad AI cosa fare dopo',
  'fabric.editor.ai.screens.preview.discardLabel': 'Ignora',
  'fabric.editor.ai.screens.preview.disclaimer': 'La qualità delle informazioni può variare.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Scopri perché',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Cancella',
  'fabric.editor.ai.screens.preview.header.edit': 'Modifica prompt',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Modifica',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Chiedi a {agentName} cosa fare dopo',
  'fabric.editor.ai.screens.preview.refineButton': 'Perfeziona',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Perfeziona',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Logo di Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Invia',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Invia ad AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} - Selezionato',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Rimuovi',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Suggerimenti',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Assistente alla scrittura',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction':
    'Chiedi ad Atlassian Intelligence di supportarti nella scrittura',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Scrivi',
  'fabric.editor.ai.shared.betaLabel': 'Beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NOVITÀ',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Dì ad AI',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': "Comunicalo all'agente",
};
